// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-dc3288a6] .alert-icon{position:relative;font-size:1.6em;font-weight:700;color:#fff;width:1.6em;height:1.6em;border-radius:50%;text-align:center;float:left;margin-right:15px;display:flex;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
